import React, { useState } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from '../../apiFormData'
import Swal from 'sweetalert2'
import FooterEdit from "../../components/FooterEdit";
import Clear from '../../assets/img/remove.svg'
import InputImage from "../../components/InputImage";
import InputCNPJ from "../../components/InputCNPJ";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import Avatar from '../../assets/img/plano-de-saude.svg'

import InputCEP from "../../components/InputCEP";

function AgreementsEdit() {
    let { id } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [error, setError] = useState({
        name: false,
        cnpj: false
    })

    const [name, setName] = useState("")
    const [address, setAddress] = useState("")
    const [addressNumber, setAddressNumber] = useState("")
    const [city, setCity] = useState("")
    const [cnpj, setCnpj] = useState("")
    const [district, setDistrict] = useState("")
    const [obs, setObs] = useState("")
    const [recordAns, setRecordAns] = useState("")
    const [state, setState] = useState("")
    const [zipCode, setZipCode] = useState("")

    const [image, setImage] = useState({
        fileReal: '',
        file: ''
    })

    const onDelete = () => {
        setShowModal(false)
        setLoading(true)
        api.delete("/api/agreements/" + id).then((response) => {
            Swal.fire({
                title: "Convênio excluído com sucesso",
                icon: 'success',
                confirmButtonColor: '#3c8dbc',
            })
            setTimeout(() => {
                Swal.close()
                setTimeout(() => {
                    navigate('/agreements')
                }, 750);
            }, 1500);
        }).catch((error) => {
            console.error(error)
            Swal.fire({
                title: "Convênio não excluído",
                text: error.message,
                icon: 'error',
                confirmButtonColor: '#3c8dbc',

            })
        }).finally(() => {
            setLoading(false)
        })

    }

    const onSubmit = (ev) => {
        ev.preventDefault()
        var cnpjClear = cnpj.replaceAll('/', '').replaceAll('.', '').replaceAll('-', '')
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            cnpj: !Validations.CNPJValid(cnpj)
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (validations) {
            var form = new FormData()
            image.fileReal !== '' ? form.set("image", image.fileReal) : console.log('')
            form.set("id", id)
            form.set("address", address);
            form.set("address_number", addressNumber);
            form.set("city", city);
            form.set("cnpj", cnpjClear);
            form.set("district", district);
            form.set("name", name);

            form.set("obs", obs);
            form.set("record_ans", recordAns);
            form.set("state", state);
            form.set("zipcode", zipCode.replaceAll('-', ''));

            setLoading(true)
            api.post("/api/agreements", form).then((response) => {

                Swal.fire({
                    title: "Convênio atualizado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })
            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Convênio não atualizado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',

                })
            }).finally(() => {
                setLoading(false)
            })
        }

    }
    const screenTela =
        <>
            {loading && <LoadingBlock />}
            <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} />
            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Convênio</h1>
                    <div className="row">
                        <h4>Dados Básicos</h4>
                        <div className="d-flex justify-content-center col-12 col-sm-4 col-lg-4">
                            <InputImage imageAvatar={Avatar} image={image} setImage={setImage} />
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">CNPJ*</label>
                                <InputCNPJ value={cnpj} onChange={setCnpj} />
                                {error.cnpj && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <InputCEP value={zipCode} onChange={setZipCode} setAddress={setAddress} setCity={setCity} setDistrict={setDistrict} setState={setState} />
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12 ">
                                <label className="form-label-input">Estado</label>
                                <select name="state" value={state} className="form-select" onChange={value => setState(value.target.value)} >
                                    <option value="" disabled >Selecione um Estado</option>
                                    <option value="AC">AC</option>
                                    <option value="AL">AL</option>
                                    <option value="AM">AM</option>
                                    <option value="AP">AP</option>
                                    <option value="BA">BA</option>
                                    <option value="CE">CE</option>
                                    <option value="DF">DF</option>
                                    <option value="ES">ES</option>
                                    <option value="GO">GO</option>
                                    <option value="MA">MA</option>
                                    <option value="MG">MG</option>
                                    <option value="MS">MS</option>
                                    <option value="MT">MT</option>
                                    <option value="PA">PA</option>
                                    <option value="PB">PB</option>
                                    <option value="PE">PE</option>
                                    <option value="PI">PI</option>
                                    <option value="PR">PR</option>
                                    <option value="RJ">RJ</option>
                                    <option value="RN">RN</option>
                                    <option value="RO">RO</option>
                                    <option value="RS">RS</option>
                                    <option value="SC">SC</option>
                                    <option value="SE">SE</option>
                                    <option value="SP">SP</option>
                                    <option value="TO">TO</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Cidade</label>
                                <input className="form-control" value={city} onChange={value => setCity(value.target.value)} type="text" name="city" placeholder="Cidade" />
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Bairro</label>
                                <input className="form-control" value={district} onChange={value => setDistrict(value.target.value)} type="text" name="district" placeholder="Bairro" />

                            </div>

                        </div>
                    </div>
                    <div className="row row-mod-hei">
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Número</label>
                            <input className="form-control" value={addressNumber} type="text" name="address_number" placeholder="Número" onChange={value => setAddressNumber(value.target.value.replace(/[a-zA-Z]/g, ''))} />
                        </div>
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Endereço</label>
                            <input className="form-control" value={address} onChange={value => setAddress(value.target.value)} type="text" name="address" placeholder="Endereço" />
                        </div>
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">ANS</label>
                            <input inputMode="numeric" className="form-control" value={recordAns} onChange={value => setRecordAns(value.target.value.replace(/[a-zA-Z]/g, ''))} type="text" name="record_ans" placeholder="ANS" />
                        </div>
                    </div>

                    <div className="row row-mod-hei">
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Observação</label>
                            <input className="form-control" value={obs} onChange={value => setObs(value.target.value)} type="text" name="obs" placeholder="Observação" />


                        </div>
                    </div>
                </div>
                <FooterEdit navigateRoute={"/agreements"} onClickDel={() => {
                    setShowModal(true)
                }} />
            </form>
        </>
    React.useEffect(() => {
        api.get('/api/agreements/' + id).then((response) => {
            var data = response.data.data
            setImage({
                fileReal: '',
                file: response.data.data.image
            })

            setAddress(data.address === null ? "" : data.address)
            setAddressNumber(data.address_number === null ? "" : data.address_number)
            setCity(data.city === null ? "" : data.city)
            setCnpj(data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"))
            setName(data.name)

            setDistrict(data.distric === null ? "" : data.district)
            setObs(data.obs === null ? "" : data.obs)
            setState(data.state === null ? "" : data.state)
            setRecordAns(data.record_ans === null ? "" : data.record_ans)
            setZipCode(data.zipcode === null ? "" : data.zipcode.replace(/^(\d{5})(\d{3})/, "$1-$2"))
        }).catch((error) => {
            console.error('Error fetching agreements:', error);
        }).finally(() => {

        })
    }, [id])

    return (
        <Menu screen={screenTela} />
    )
}

export default AgreementsEdit;